export const SHORT_BACKGROUND_MAX_MS = 10_000;
export const RECONNECT_TICKET_MAX_AGE_MS = 6 * 60 * 60 * 1000;

export function shouldDisconnectImmediately(reason) {
  return reason === 'pagehide' || reason === 'freeze';
}

export function classifyBackgroundDuration(durationMs) {
  const duration = Math.max(0, Number(durationMs) || 0);
  if (duration <= SHORT_BACKGROUND_MAX_MS) return 'short';
  if (duration < RECONNECT_TICKET_MAX_AGE_MS) return 'long';
  return 'expired';
}

export function shouldClearPendingBets({ mode, previousRoundKey, currentRoundKey, bettingOpen }) {
  if (mode !== 'short') return true;
  if (!bettingOpen) return true;
  if (!previousRoundKey || !currentRoundKey) return true;
  return String(previousRoundKey) !== String(currentRoundKey);
}
